var map = {
	"./A5_beiwen.png": 67857,
	"./A5_beiwenAc.png": 59840,
	"./A5_gesture.png": 97532,
	"./A5_line.png": 75600,
	"./A5_lineAc.png": 12774,
	"./A5_reset.png": 4013,
	"./A5_size.png": 1428,
	"./A5_sizeAc.png": 61906,
	"./A5_tapian.png": 56447,
	"./A5_tapian1.png": 19236,
	"./A5_tapian2.jpg": 33005,
	"./A5_tapian2.png": 18743,
	"./A5_tapian3.png": 50302,
	"./A5_tapianAc.png": 16772,
	"./A5_xiantu1.png": 25580,
	"./A5_xiantu2.png": 86827,
	"./A5_xiantu3.png": 11506,
	"./A5_zoomin.png": 76021,
	"./A5_zoomout.png": 36531
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26977;